const basicFields = [
  {
    ID: 10,
    accessor: "data_10",
    Header: "Checklist Column",
    typeDictID: 1,
    sheetID: 4,
    orderBy: 1,
    isShared: false,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
  {
    ID: 11,
    accessor: "data_11",
    Header: "Text Column",
    typeDictID: 2,
    sheetID: 4,
    orderBy: 2,
    isShared: false,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
  {
    ID: 12,
    accessor: "data_12",
    Header: "Number Column",
    typeDictID: 3,
    sheetID: 4,
    orderBy: 3,
    isShared: false,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
];

const extendedFields = [
  {
    ID: 424,
    accessor: "data_424",
    Header: "Shirt Size",
    typeDictID: 8,
    sheetID: 4,
    orderBy: 5,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "picker",
      icon: "male fas",
      multiSelect: false,
      options: [
        {
          ID: 1,
          title: "XS",
        },
        {
          ID: 2,
          title: "Small",
        },
        {
          ID: 3,
          title: "Medium",
        },
        {
          ID: 4,
          title: "Large",
        },
        {
          ID: 5,
          title: "XL",
        },
        {
          ID: 6,
          title: "XXL",
        },
        {
          ID: 7,
          title: "XXXL",
        },
      ],
      entityType: "user",
      title: "Shirt Size",
      networkAvailableFieldID: 1,
    },
  },
  {
    ID: 308,
    accessor: "data_308",
    Header: "Gender",
    typeDictID: 8,
    sheetID: 4,
    orderBy: 6,
    isShared: true,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "picker",
      icon: "venus-mars fas",
      multiSelect: false,
      options: [
        {
          ID: 8,
          title: "Female",
        },
        {
          ID: 9,
          title: "Male",
        },
      ],
      entityType: "user",
      title: "Gender",
      networkAvailableFieldID: 2,
    },
  },
];

const sacramentFields = [
  {
    ID: 999,
    fieldTypeInstanceStructureGroupingID: 1, // 1 means this is a sacrament
    accessor: "data_999",
    Header: "Baptism Godparents",
    typeDictID: 2,
    sheetID: 4,
    orderBy: 7,
    isShared: true,
    canEdit: false,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFiledData: {
      type: "text",
      icon: "keyboard fas",
      multiline: false,
      entityType: "user",
      title: "Baptism Godparents",
      networkAvailableFieldID: 32,
    },
  },
];

export const addColumn = {
  success: true,
  columns: [
    {
      Header: "",
      accessor: "name",
    },
    // ...basicFields,
    // ...extendedFields,
    ...sacramentFields,
  ],
  newColumnID: 424,
  isApp: false,
  userID: 2,
};
